import NavBrandImg from "../assets/navbarBrand.png";
// Hero
import HeroImg1 from "../assets/hero-img.webp";
import HeroImg2 from "../assets/hero-img2.webp";
import HeroImg3 from "../assets/hero-img3.webp";
// Category
import tshirts from "../assets/category-tshirts.svg";
import jeans from "../assets/category-jeans.svg";
import kurtas from "../assets/category-kurtas.svg";
import shoes from "../assets/category-shoes.svg";
import sarees from "../assets/category-sarees.svg";
import trousers from "../assets/category-trousers.svg";
// top-brand
import hrx from "../assets/hrx.webp";
import roadster from "../assets/roadster.svg";
import wrogn from "../assets/wrogn.svg";
// wishlist
import wishlistSVG from "../assets/wishlist.svg";
import shopNowSVG from "../assets/shopNow.svg";
import error404 from "../assets/404.svg";

const HeroImage = [HeroImg3, HeroImg1, HeroImg2];
const CategoryImage = { tshirts, jeans, kurtas, shoes, sarees, trousers };
const topBrandImages = { hrx, roadster, wrogn };

export { NavBrandImg, HeroImage, CategoryImage, topBrandImages, wishlistSVG,shopNowSVG ,error404};
